import { BULK_FILTER_VALUE_SEPARATOR } from '@aibees/elephant/constants/filters';

export function useBulkFilterValuesCount(
  includeParams?: string,
  excludeParams?: string
) {
  const includeCount = includeParams?.split(BULK_FILTER_VALUE_SEPARATOR)[1];
  const excludeCount = excludeParams?.split(BULK_FILTER_VALUE_SEPARATOR)[1];
  return (Number(includeCount) || 0) + (Number(excludeCount) || 0);
}
